function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 50.74 0 62.23 53.61 62.55 53.61 72.28 0 104.35 0 113.92 53.61 114.24 53.61 125.9 0 171.86 0 137.87 115.53 95.9 115.53 86.01 70.53 85.69 70.53 75.96 115.53 33.83 115.53"
}), React.createElement("path", {
  d: "M195.3,0 L240.78,0 L284.82,115.53 L233.44,115.53 L229.45,100.37 L202.96,100.37 L198.49,115.53 L151.26,115.53 L195.3,0 Z M221.79,71.33 L216.68,47.87 L216.36,47.87 L211.25,71.33 L221.79,71.33 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M330.77,0 L376.25,0 L420.29,115.53 L368.9,115.53 L364.91,100.37 L338.42,100.37 L333.95,115.53 L286.72,115.53 L330.77,0 Z M357.26,71.33 L352.15,47.87 L351.83,47.87 L346.72,71.33 L357.26,71.33 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M425.07,-7.10542736e-15 L472.46,-7.10542736e-15 C496.24,-7.10542736e-15 528.63,5.9 528.63,36.7 C528.63,49.14 522.73,58.08 514.11,64.14 L540.44,115.52 L490.49,115.52 L473.26,77.54 L472.62,77.54 L472.62,115.52 L425.07,115.52 L425.07,-7.10542736e-15 L425.07,-7.10542736e-15 Z M476.13,51.06 C483.63,51.06 486.98,47.07 486.98,42.12 C486.98,37.17 483.47,33.34 476.13,33.34 L472.62,33.34 L472.62,51.05 L476.13,51.05 L476.13,51.06 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M542.19,115.53 L542.19,0 L590.54,0 C612.88,0 630.11,6.86 641.76,18.03 C651.97,27.77 658.52,41.01 658.52,57.76 C658.52,73.72 652.45,87.44 642.08,97.33 C630.11,108.82 612.72,115.52 590.86,115.52 L542.19,115.52 L542.19,115.53 Z M589.74,77.87 L590.86,77.87 C598.84,77.87 604.9,75.32 608.73,71.33 C611.92,67.98 613.99,63.35 613.99,57.76 C613.99,52.02 611.92,47.23 608.73,43.88 C605.38,40.37 599.95,37.66 591.18,37.66 L589.74,37.66 L589.74,77.87 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "666.8 -7.10542736e-15 749.93 -7.10542736e-15 749.93 38.61 714.35 38.61 714.35 44.83 743.07 44.83 743.07 72.28 714.35 72.28 714.35 78.82 752.17 78.82 752.17 115.52 666.8 115.52"
}), React.createElement("polygon", {
  id: "Path",
  points: "760.78 -7.10542736e-15 843.91 -7.10542736e-15 843.91 38.61 808.33 38.61 808.33 44.83 837.05 44.83 837.05 72.28 808.33 72.28 808.33 78.82 846.15 78.82 846.15 115.52 760.78 115.52"
}), React.createElement("path", {
  d: "M854.76,-7.10542736e-15 L902.15,-7.10542736e-15 C925.92,-7.10542736e-15 958.32,5.9 958.32,36.7 C958.32,49.14 952.42,58.08 943.8,64.14 L970.13,115.52 L920.19,115.52 L902.96,77.54 L902.32,77.54 L902.32,115.52 L854.77,115.52 L854.77,-7.10542736e-15 L854.76,-7.10542736e-15 Z M905.83,51.06 C913.33,51.06 916.68,47.07 916.68,42.12 C916.68,37.17 913.17,33.34 905.83,33.34 L902.32,33.34 L902.32,51.05 L905.83,51.05 L905.83,51.06 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "1016.56 0 1064.11 0 1064.11 35.74 1088.04 35.74 1088.04 0 1135.59 0 1135.59 115.53 1088.04 115.53 1088.04 73.4 1064.11 73.4 1064.11 115.53 1016.56 115.53"
}), React.createElement("polygon", {
  id: "Path",
  points: "1146.44 -7.10542736e-15 1229.57 -7.10542736e-15 1229.57 38.61 1193.99 38.61 1193.99 44.83 1222.71 44.83 1222.71 72.28 1193.99 72.28 1193.99 78.82 1231.81 78.82 1231.81 115.52 1146.44 115.52"
}), React.createElement("polygon", {
  id: "Path",
  points: "1271.06 39.25 1238.83 39.25 1238.83 -7.10542736e-15 1350.85 -7.10542736e-15 1350.85 39.25 1318.62 39.25 1318.62 115.52 1271.07 115.52 1271.07 39.25"
})));

var SvgWaardeerHet = function SvgWaardeerHet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1351px",
    height: "116px",
    viewBox: "0 0 1351 116",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWaardeerHet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waardeer-het.ba327dcc.svg";
export { ForwardRef as ReactComponent };